import * as Yup from 'yup';

const creditCardValidationSchema = (renderContent) =>
  Yup.object().shape({
    firstNameOnCard: Yup.string().required(
      renderContent('formBookingAmendRequiredFirstName', 'First name is required'),
    ),
    lastNameOnCard: Yup.string(
      renderContent('formBookingAmendFieldLastName', 'Enter your last namne'),
    ).required(renderContent('formBookingAmendRequiredLastName', 'Last name is required')),
    cardNumber: Yup.string(
      renderContent('paymentBookingAmendCardNumberRequired', 'Enter a valid credit card number'),
    ).required(
      renderContent('paymentBookingAmendCardNumberRequired', 'Enter a valid credit card number'),
    ),
  });

export default creditCardValidationSchema;
